import { WHATSAPP_ERRORS } from "@markedesk/core-contracts";
import { backendErrorCode } from "../errors/backendErrorCode";

/**
 * Decisões de UI por conexão que dependem do CANAL e do SERVIDOR, não só do
 * status. #4418
 */

/**
 * Canais que pareiam por QR: o Baileys nativo e qualquer plugin de WhatsApp
 * (whatsapp_*). Os demais (telegram, discord, oficial...) conectam por token
 * e "Novo QR" não significa nada para eles.
 */
export function channelPairsByQr(channel) {
  if (!channel) return false;
  if (channel === "whatsapp_oficial") return false;
  return channel === "whatsapp" || channel.startsWith("whatsapp_");
}

/**
 * Multi-servidor: o backend marca cada conexão com `managedByThisServer`.
 * Sem a marca (backend antigo ou single-server) é gerenciável.
 */
export function canManageHere(whatsApp) {
  return whatsApp?.managedByThisServer !== false;
}

/** "Novo QR" só faz sentido desconectado, em canal que pareia por QR e neste servidor. */
export function canRequestNewQr(whatsApp) {
  return (
    canManageHere(whatsApp) &&
    whatsApp?.status === "DISCONNECTED" &&
    channelPairsByQr(whatsApp.channel)
  );
}

/**
 * O backend recusou porque a conexão é de outro servidor (409, código do
 * core-contracts). A lista pode estar velha — a conexão migrou depois do
 * carregamento — e a tela marca a linha na hora em vez de esperar o polling.
 */
export function isOtherServerError(err) {
  return backendErrorCode(err) === WHATSAPP_ERRORS.OTHER_SERVER;
}
